import React from 'react'
import CheckoutStripeForm from '../../components/Forms/CheckoutStripeForm/CheckoutStripeForm';

const CheckoutPage = () => {
    return (
        <div className='py-5'>
          <CheckoutStripeForm  />
        </div>
      );
}

export default CheckoutPage